var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimesheet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_94_4631",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#828282"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_94_4631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.75 4.8H15.05V3.45C15.05 3.33065 15.0026 3.21619 14.9182 3.1318C14.8338 3.04741 14.7193 3 14.6 3C14.4807 3 14.3662 3.04741 14.2818 3.1318C14.1974 3.21619 14.15 3.33065 14.15 3.45V4.8H7.85V3.45C7.85 3.33065 7.80259 3.21619 7.7182 3.1318C7.63381 3.04741 7.51935 3 7.4 3C7.28065 3 7.16619 3.04741 7.0818 3.1318C6.99741 3.21619 6.95 3.33065 6.95 3.45V4.8H4.25C3.65348 4.80071 3.0816 5.038 2.6598 5.4598C2.238 5.8816 2.00071 6.45348 2 7.05V18.75C2.00071 19.3465 2.238 19.9184 2.6598 20.3402C3.0816 20.762 3.65348 20.9993 4.25 21H17.75C18.3466 20.9995 18.9186 20.7623 19.3405 20.3405C19.7623 19.9186 19.9995 19.3466 20 18.75V7.05C19.9995 6.45341 19.7623 5.88139 19.3405 5.45954C18.9186 5.03768 18.3466 4.80048 17.75 4.8ZM18.7046 19C18.7046 19.4219 18.7046 19.7046 18.7046 19.7046C18.7046 19.7046 18.108 19.7046 17.75 19.7046H4.25C3.89196 19.7046 3.64062 19.7046 3.29541 19.7046C3.29541 19.4141 3.29541 19.358 3.29541 19V11.1H18.7046V19ZM18.7046 10.2H3.29541V7.05C3.29541 6.3048 3.503 5.7 4.25 5.7H6.95V7.05C6.95 7.16935 6.99741 7.28381 7.0818 7.3682C7.16619 7.45259 7.28065 7.5 7.4 7.5C7.51935 7.5 7.63381 7.45259 7.7182 7.3682C7.80259 7.28381 7.85 7.16935 7.85 7.05V5.7H14.15V7.05C14.15 7.16935 14.1974 7.28381 14.2818 7.3682C14.3662 7.45259 14.4807 7.5 14.6 7.5C14.7193 7.5 14.8338 7.45259 14.9182 7.3682C15.0026 7.28381 15.05 7.16935 15.05 7.05V5.7H17.75C18.108 5.7 18.2468 5.74683 18.5 6C18.7532 6.25317 18.7046 6.51696 18.7046 6.875V10.2Z",
    fill: "#828282",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 4.4,
    stroke: "#828282",
    strokeOpacity: 0.5,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5835 14.083V17.4163H20.0835",
    stroke: "#828282",
    strokeOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesheet);
export default __webpack_public_path__ + "static/media/timesheet.865658f4b87bc977346db89fa0017aed.svg";
export { ForwardRef as ReactComponent };